import shp from 'shpjs';
import LayerGroup from 'ol/layer/Group';
import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Style, Stroke, Fill } from 'ol/style';
import GeoJSON from 'ol/format/GeoJSON';
import KML from 'ol/format/KML';
import { proyeccion3857, mensaje } from './configuracion';

const subirArchivo = document.getElementById('subirArchivo'),
    limpiarArchivo = document.getElementById('limpiarArchivo'),
    archivoZipKml = document.getElementById('archivoZipKml');

function archivoZipFile(file) {
    const r = new FileReader();
    r.onload = function () {
        if (r.readyState !== 2 || r.error) return;
        else convertirCapaShp(r.result, file.name);
    };
    r.readAsArrayBuffer(file);
}

function archivoKmlFile(file) {
    const r = new FileReader();
    r.onload = function () {
        if (r.readyState !== 2 || r.error) return;
        else convertirCapaKml(r.result, file.name);
    };
    r.readAsText(file);
}

function convertirCapaKml(data, nombreKml) {
    const formatoKml = new KML();
    const features = formatoKml.readFeatures(data, {
        featureProjection: proyeccion3857
    });
    agregarCapa(features, 'archivoKML', nombreKml);
}

function convertirCapaShp(buffer, nombreShp) {
    shp(buffer).then(function (geojson) {
        const formatoGeoJson = new GeoJSON();
        const features = formatoGeoJson.readFeatures(geojson, {
            featureProjection: proyeccion3857
        });
        agregarCapa(features, 'archivoSHP', nombreShp);
    });
}

function agregarCapa(features, capaId, capaNombre) {
    const vectorSource = new VectorSource({
        features: features,
    });

    const vectorLayer = new VectorLayer({
        source: vectorSource,
        name: capaId,
        id: capaId,
        title: capaNombre,
        style: new Style({
            stroke: new Stroke({
                color: '#ffff00',
                width: 1
            }),
            fill: new Fill({
                color: 'rgba(100, 100, 100, 0.25)'
            })
        })
    });
    
    global.grupoCapasExternos.getLayers().push(vectorLayer);
    global.layerSwitcher.renderPanel();
    const extension = vectorSource.getExtent();
    global.vista.fit(extension, {
        size: global.mapa.getSize(),
        maxZoom: global.vista.getMaxZoom() - 1,
    });
    limpiarArchivo.classList.remove('disabled');
}

subirArchivo.addEventListener('click', function () {
    const files = archivoZipKml.files;
    if (files && files.length > 0) {
        const file = files[0];
        const extension = file.name.split('.').pop().toLowerCase();
        
        if (extension === 'zip') {
            archivoZipFile(file);
        } else if (extension === 'kml' || extension === 'kmz') {
            archivoKmlFile(file);
        } else {
            mensaje('mensajeCargar', 'Formato de archivo no soportado', 'danger');
        }
    }
});

limpiarArchivo.addEventListener('click', function () {

    global.gruposDeCapas.forEach(grupo => {
        if (grupo instanceof LayerGroup) {
            grupo.getLayers().forEach(layer => {
                if (layer.get('id') === 'archivoSHP' || layer.get('id') === 'archivoKML') {
                    archivoZipKml.value = '';                    
                    limpiarArchivo.classList.add('disabled');
                    grupo.getLayers().remove(layer);
                    global.layerSwitcher.renderPanel();
                }
            });
        }
    });    
});